// TODO: rename to sensorType
const meterType = {
	WATER_METER: 'WATER_METER',
	PRVN: 'PRVN',
	C5: 'C5', // MERAČ TEPLA/ MERAČ CHLADU ZELSIUS® C5 ISF
	UNKNOWN: 'UNKNOWN'
}

const nameTypeByType = (type) => {
	switch (type) {
		case meterType.WATER_METER:
			return 'Voda'
		case meterType.PRVN:
			return 'PRVN'
		case meterType.C5:
			return 'Teplo'
		default:
			return 'Neznámy typ'
	}
}

const unitByType = (type) => {
	switch (type) {
		case meterType.WATER_METER:
			return '㎥'
		case meterType.PRVN:
			return ''
		case meterType.C5:
			return 'kWh'
		default:
			return ''
	}
}

const tableNameByType = {
	[meterType.WATER_METER]: 'water_meter',
	[meterType.PRVN]: 'prvn',
	[meterType.C5]: 'c5'
}

module.exports = {
	meterType,
	nameTypeByType,
	unitByType,
	tableNameByType
}
